import Checkbox from "./Checkbox";
import { COLORS, SIZES } from "./utilities";

export { COLORS, SIZES };
export default Checkbox;
